/* eslint-disable no-console */
import {message} from "antd"
import * as API from './api';
import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import { showMessage, showNotification, log, setDataInLocalStorage, reloadPage } from '../../config/utils';
import { MODULE_MESSAGE, BRAND_INFO } from '../../config/urls';
import { LOCAL_STORAGE } from '../../config/constants'

export const resetReduxState = () => {
  return {
    type: actionTypes.RESET_REDUX_STATE
  }
}

export const updateAdminState = payload => {
  return {
    type: actionTypes.UPDATE_ADMIN_STATE,
    payload,
  }
};

export const changeAgentState = payload => {
  return {
    type: actionTypes.CHANGE_AGENT_STATE,
    payload,
  }
};

export const loginUser = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.AUTH_LOADING
    });
    API.loginUser(payload, (error, response) => {
      dispatch({
        type: actionTypes.AUTH_LOADED
      });
      log('user login response', response);
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.LOGIN_SUCCESS,
          payload: response.data,
        });
        showMessage('success', response.data.user ? `Hi ${response.data.user.firstName}, Welcome to ${BRAND_INFO.shortend_name} dashboard` : `Welcome to ${BRAND_INFO.shortend_name} dashboard`);
      }
      if (callback) callback(error, response);
    });
  };
};

export const forgotPassword = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.AUTH_LOADING
    });
    API.forgotPassword(payload, (error, response) => {
      dispatch({
        type: actionTypes.AUTH_LOADED
      });
      log('forgot pasword response', response);
      if (!error && response) {
        if (callback) callback();
        showNotification('success', MODULE_MESSAGE.AUTH.FORGOT_PASSWORD.request_success_title, MODULE_MESSAGE.AUTH.FORGOT_PASSWORD.request_success_description, 'topLeft');
      }
    });
  };
}

export const verifyToken = payload => {
  return dispatch => {
    dispatch({
      type: actionTypes.TOKEN_VERIFYING,
    });
    API.verifyToken(payload, (error, response) => {
      log('verify token response', response);
      if (!error && response) {
        dispatch({
          type: actionTypes.TOKEN_VERIFIED,
          payload: response.data
        });
      } else {
        dispatch({
          type: actionTypes.TOKEN_VERIFICATION_FAILED
        });
      }
    });
  };
}

export const resetPassword = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.AUTH_LOADING
    });
    API.resetPassword(payload, (error, response) => {
      dispatch({
        type: actionTypes.AUTH_LOADED
      });
      log('reset pasword response', response);
      if (!error && response) {
        showMessage('success', 'your password has been successfully updated');
        if (callback) callback();
      }
    });
  };
}

export const activateUser = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.AUTH_LOADING
    });
    API.activateUser(payload, (error, response) => {
      dispatch({
        type: actionTypes.AUTH_LOADED
      });
      log('activate user response', response);
      if (!error && response) {
        showMessage('success', 'your account has been successfully activated');
        if (callback) callback();
      }
    });
  };
}

export const resendActivationLink = (payload, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.AUTH_LOADING
    });
    API.resendActivationLink(payload, (error, response) => {
      dispatch({
        type: actionTypes.AUTH_LOADED
      });
      log('resend activation link response', response);
      if (!error && response) {
        showNotification('success', MODULE_MESSAGE.AUTH.ACTIVATE_USER.request_success_title, MODULE_MESSAGE.AUTH.ACTIVATE_USER.request_success_description, 'topLeft');
      }
      if (callback) callback();
    });
  };
}

export const updateUserProfile = data => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "Profile updating"
    });
    API.updateUserProfile(data, (error, response) => {
      log('update user profile response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data && response.data.user && response.data.user.length > 0) {
        dispatch({
          type: actionTypes.UPDATE_USER_INFO,
          payload: response.data.user[0]
        });
        showMessage('success', 'profile details has been successfully updated');
      }
    });
  };
}

export const logOutUser = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "Logging out"
    });
    API.logOutUser(data, error => {
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && callback)
        callback();
    });
  };
}

export const updateBifurcation = (data, bifurcation) => dispatch => {
  dispatch({
    type: PAGE_LOADING,
    payload: "Bifurcation Loading"
  })
  API.updateBifurcation(data, (error,res) => {
    dispatch({
      type: PAGE_LOADED,
    })
    if (!error && res && res.data && res.data.adminPsid === data.adminPsid && res.data.selectedBifurcation) {
      const bifurcation_data = {
        ...bifurcation,
        selected: res.data.selectedBifurcation,
      }
      setDataInLocalStorage(LOCAL_STORAGE.BIFURCATION_DATA, bifurcation_data)
      dispatch(updateAdminState({ bifurcation_data }))
      message.success(res.message ? res.message : "Bifurcation is successfully updated")
        .then(() => message.loading("Dashboard will reload soon"))
        .then(reloadPage)
    }
  }
  )
}



// WEBPACK FOOTER //
// ./src/data/redux/admin_details/actions.js